/* tslint:disable */
/* eslint-disable */
/**
 * Flight Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { AddBillResponse } from '../model';
// @ts-ignore
import { CheckFinalizabilityResponse } from '../model';
// @ts-ignore
import { FlightType } from '../model';
// @ts-ignore
import { GetNewTicketResponse } from '../model';
// @ts-ignore
import { RegisterReserveInfoRequest } from '../model';
// @ts-ignore
import { TicketOfReserveResponse } from '../model';
// @ts-ignore
import { UserRequestHeaders } from '../model';
/**
 * ReserveApiApiReserveBillIdDelete - axios parameter creator
 * 
 * @summary  (Auth policies: Flight:DeleteReserve)
 * @param {number} billId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveBillIdDeleteAxiosParamCreator (billId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billId' is not null or undefined
    assertParamExists('apiReserveBillIdDelete', 'billId', billId)
    const localVarPath = `/api/Reserve/{billId}`
        .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveCheckFinalizabilityGet - axios parameter creator
 * 
 * @summary این اند پوینت قبل از فاینالایز رزرو کال میشه و یکسری شرایط رو بررسی میکنه (Auth policies: Flight:CheckFinalizability)
 * @param {number} [billId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveCheckFinalizabilityGetAxiosParamCreator (billId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Reserve/CheckFinalizability`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (billId !== undefined) {
        localVarQueryParameter['billId'] = billId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveCreateFlightBillPost - axios parameter creator
 * 
 * @param {UserRequestHeaders} [requestHeaders] 
 * @param {RegisterReserveInfoRequest} [registerReserveInfoRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveCreateFlightBillPostAxiosParamCreator (requestHeaders?: UserRequestHeaders, registerReserveInfoRequest?: RegisterReserveInfoRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Reserve/CreateFlightBill`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (requestHeaders != null) {
        localVarHeaderParameter['requestHeaders'] = typeof requestHeaders === 'string'
            ? requestHeaders
            : JSON.stringify(requestHeaders);
    }



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(registerReserveInfoRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveReserveCheckFinalizabilityGet - axios parameter creator
 * 
 * @summary این اند پوینت قبل از فاینالایز رزرو کال میشه و یکسری شرایط رو بررسی میکنه (Auth policies: Flight:CheckFinalizability)
 * @param {number} [billId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveReserveCheckFinalizabilityGetAxiosParamCreator (billId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Reserve/Reserve/CheckFinalizability`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (billId !== undefined) {
        localVarQueryParameter['billId'] = billId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveReserveIdTypeReserveTicketsGet - axios parameter creator
 * 
 * @summary دریافت بلیط پرواز اصلی که استفاده میشه (Auth policies: TicketGenerator)
 * @param {number} reserveId 
 * @param {FlightType} type 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveReserveIdTypeReserveTicketsGetAxiosParamCreator (reserveId: number, type: FlightType, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'reserveId' is not null or undefined
    assertParamExists('apiReserveReserveIdTypeReserveTicketsGet', 'reserveId', reserveId)
    // verify required parameter 'type' is not null or undefined
    assertParamExists('apiReserveReserveIdTypeReserveTicketsGet', 'type', type)
    const localVarPath = `/api/Reserve/{reserveId}/{type}/ReserveTickets`
        .replace(`{${"reserveId"}}`, encodeURIComponent(String(reserveId)))
        .replace(`{${"type"}}`, encodeURIComponent(String(type)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveReserveIdTypeTicketsGet - axios parameter creator
 * 
 * @summary دریافت بلیط که منسوخ شده است (Auth policies: Flight:Ticket)
 * @param {number} reserveId 
 * @param {FlightType} type 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveReserveIdTypeTicketsGetAxiosParamCreator (reserveId: number, type: FlightType, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'reserveId' is not null or undefined
    assertParamExists('apiReserveReserveIdTypeTicketsGet', 'reserveId', reserveId)
    // verify required parameter 'type' is not null or undefined
    assertParamExists('apiReserveReserveIdTypeTicketsGet', 'type', type)
    const localVarPath = `/api/Reserve/{reserveId}/{type}/tickets`
        .replace(`{${"reserveId"}}`, encodeURIComponent(String(reserveId)))
        .replace(`{${"type"}}`, encodeURIComponent(String(type)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiReserveBillIdDelete operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveBillIdDeleteRequest
 */
export interface ReserveApiApiReserveBillIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ReserveApiApiReserveBillIdDelete
     */
    readonly billId: number
}

/**
 * Request parameters for apiReserveCheckFinalizabilityGet operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveCheckFinalizabilityGetRequest
 */
export interface ReserveApiApiReserveCheckFinalizabilityGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ReserveApiApiReserveCheckFinalizabilityGet
     */
    readonly billId?: number
}

/**
 * Request parameters for apiReserveCreateFlightBillPost operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveCreateFlightBillPostRequest
 */
export interface ReserveApiApiReserveCreateFlightBillPostRequest {
    /**
     * 
     * @type {UserRequestHeaders}
     * @memberof ReserveApiApiReserveCreateFlightBillPost
     */
    readonly requestHeaders?: UserRequestHeaders

    /**
     * 
     * @type {RegisterReserveInfoRequest}
     * @memberof ReserveApiApiReserveCreateFlightBillPost
     */
    readonly registerReserveInfoRequest?: RegisterReserveInfoRequest
}

/**
 * Request parameters for apiReserveReserveCheckFinalizabilityGet operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveReserveCheckFinalizabilityGetRequest
 */
export interface ReserveApiApiReserveReserveCheckFinalizabilityGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ReserveApiApiReserveReserveCheckFinalizabilityGet
     */
    readonly billId?: number
}

/**
 * Request parameters for apiReserveReserveIdTypeReserveTicketsGet operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveReserveIdTypeReserveTicketsGetRequest
 */
export interface ReserveApiApiReserveReserveIdTypeReserveTicketsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ReserveApiApiReserveReserveIdTypeReserveTicketsGet
     */
    readonly reserveId: number

    /**
     * 
     * @type {FlightType}
     * @memberof ReserveApiApiReserveReserveIdTypeReserveTicketsGet
     */
    readonly type: FlightType
}

/**
 * Request parameters for apiReserveReserveIdTypeTicketsGet operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveReserveIdTypeTicketsGetRequest
 */
export interface ReserveApiApiReserveReserveIdTypeTicketsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ReserveApiApiReserveReserveIdTypeTicketsGet
     */
    readonly reserveId: number

    /**
     * 
     * @type {FlightType}
     * @memberof ReserveApiApiReserveReserveIdTypeTicketsGet
     */
    readonly type: FlightType
}

/**
* 
* @summary  (Auth policies: Flight:DeleteReserve)
* @param {ReserveApiApiReserveBillIdDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveBillIdDelete(requestParameters: ReserveApiApiReserveBillIdDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveBillIdDeleteAxiosParamCreator(requestParameters.billId, options, configuration);
    const request: () => AxiosPromise<GetNewTicketResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary این اند پوینت قبل از فاینالایز رزرو کال میشه و یکسری شرایط رو بررسی میکنه (Auth policies: Flight:CheckFinalizability)
* @param {ReserveApiApiReserveCheckFinalizabilityGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveCheckFinalizabilityGet(requestParameters: ReserveApiApiReserveCheckFinalizabilityGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveCheckFinalizabilityGetAxiosParamCreator(requestParameters.billId, options, configuration);
    const request: () => AxiosPromise<CheckFinalizabilityResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReserveApiApiReserveCreateFlightBillPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveCreateFlightBillPost(requestParameters: ReserveApiApiReserveCreateFlightBillPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveCreateFlightBillPostAxiosParamCreator(requestParameters.requestHeaders, requestParameters.registerReserveInfoRequest, options, configuration);
    const request: () => AxiosPromise<AddBillResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary این اند پوینت قبل از فاینالایز رزرو کال میشه و یکسری شرایط رو بررسی میکنه (Auth policies: Flight:CheckFinalizability)
* @param {ReserveApiApiReserveReserveCheckFinalizabilityGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveReserveCheckFinalizabilityGet(requestParameters: ReserveApiApiReserveReserveCheckFinalizabilityGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveReserveCheckFinalizabilityGetAxiosParamCreator(requestParameters.billId, options, configuration);
    const request: () => AxiosPromise<CheckFinalizabilityResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary دریافت بلیط پرواز اصلی که استفاده میشه (Auth policies: TicketGenerator)
* @param {ReserveApiApiReserveReserveIdTypeReserveTicketsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveReserveIdTypeReserveTicketsGet(requestParameters: ReserveApiApiReserveReserveIdTypeReserveTicketsGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveReserveIdTypeReserveTicketsGetAxiosParamCreator(requestParameters.reserveId, requestParameters.type, options, configuration);
    const request: () => AxiosPromise<GetNewTicketResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary دریافت بلیط که منسوخ شده است (Auth policies: Flight:Ticket)
* @param {ReserveApiApiReserveReserveIdTypeTicketsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveReserveIdTypeTicketsGet(requestParameters: ReserveApiApiReserveReserveIdTypeTicketsGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveReserveIdTypeTicketsGetAxiosParamCreator(requestParameters.reserveId, requestParameters.type, options, configuration);
    const request: () => AxiosPromise<Array<TicketOfReserveResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
